export const notifications = {
  namespaced: true,

  state: {
    notifications: []
  },

  mutations: {
    ADD (state, notification) {
      state.notifications.push(notification);
    },
    REMOVE (state, notificationToRemove) {
      state.notifications = state.notifications.filter(notification => notification.id !== notificationToRemove.id);
    }
  },

  actions: {
    addNotification ({ commit }, payload) {
      commit('ADD', payload);
    },
    removeNotification ({ commit }, payload) {
      commit('REMOVE', payload);
    }
  }
};
